import { motion, AnimatePresence } from 'framer-motion';

export interface RollingNumberProps {
  /** The numeric value to display */
  value: number;
  /** Optional className for the container */
  className?: string;
  /** Optional inline styles */
  style?: React.CSSProperties;
  /** Min width per digit slot (default 0.6em). Use smaller value (e.g. 0.4em) for tight scoreboard style */
  digitMinWidth?: string;
}

/**
 * Displays a number with a slot-machine/odometer style rolling animation when the value changes.
 * Each digit animates independently for a slick score-update effect.
 */
export default function RollingNumber({
  value,
  className = '',
  style,
  digitMinWidth = '0.6em',
}: RollingNumberProps) {
  const digits = String(Math.max(0, Math.floor(value))).split('');

  return (
    <span className={`inline-flex tabular-nums ${className}`} style={style}>
      {digits.map((digit, index) => (
        <span
          key={`pos-${index}`}
          className="inline-block overflow-hidden align-top h-[1.2em] leading-none"
          style={{ minWidth: digitMinWidth }}
        >
          <AnimatePresence initial={false}>
            <motion.span
              key={digit}
              initial={{ y: '100%' }}
              animate={{ y: 0 }}
              exit={{ y: '-100%' }}
              transition={{
                type: 'spring',
                stiffness: 500,
                damping: 35,
              }}
              className="block"
            >
              {digit}
            </motion.span>
          </AnimatePresence>
        </span>
      ))}
    </span>
  );
}
